<template>
  <el-table-column
    prop="ctn.value"
    sortable="custom"
    label="VTSZ"
    show-overflow-tooltip
    min-width="100"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.ctn">{{ scope.row.ctn.value }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'ctn.value',
  };
</script>
